var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{attrs:{"color":"red","content":_vm.value > 9 ? '9+' : _vm.value,"value":_vm.value,"overlap":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }